'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n      border-color: ', ';\n\n      &:hover {\n        border-color: ', ';\n      }\n    '], ['\n      border-color: ', ';\n\n      &:hover {\n        border-color: ', ';\n      }\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      border: solid 1px ', ';\n      opacity: 0.5;\n      pointer-events: none;\n    '], ['\n      border: solid 1px ', ';\n      opacity: 0.5;\n      pointer-events: none;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      border-color: ', ';\n      z-index: 1;\n    '], ['\n      border-color: ', ';\n      z-index: 1;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      height: auto;\n      min-height: ', ';\n    '], ['\n      height: auto;\n      min-height: ', ';\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      border-color: ', ';\n      cursor: not-allowed;\n      z-index: 0;\n\n      &:hover {\n        border-color: ', ';\n        z-index: 0;\n      }\n\n      ', ' {\n        display: none;\n        pointer-events: none;\n      }\n    '], ['\n      background-color: ', ';\n      border-color: ', ';\n      cursor: not-allowed;\n      z-index: 0;\n\n      &:hover {\n        border-color: ', ';\n        z-index: 0;\n      }\n\n      ', ' {\n        display: none;\n        pointer-events: none;\n      }\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border: solid 1px ', ';\n  height: ', ';\n  transition: border-color 200ms ease;\n\n  &:hover {\n    border-color: ', ';\n    z-index: 1;\n  }\n'], ['\n  background-color: ', ';\n  border: solid 1px ', ';\n  height: ', ';\n  transition: border-color 200ms ease;\n\n  &:hover {\n    border-color: ', ';\n    z-index: 1;\n  }\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _polished = require('polished');

var _decisivUiUtils = require('decisiv-ui-utils');

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _ActionButton = require('./ActionButton');

var _ActionButton2 = _interopRequireDefault(_ActionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var modifierConfig = {
  borderWarning: function borderWarning(_ref) {
    var theme = _ref.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject, theme.colors.status.warning, theme.colors.status.warning)
    };
  },

  disabled: function disabled(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject2, theme.colors.base.chrome400)
    };
  },

  focused: function focused(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject3, theme.colors.base.chrome600)
    };
  },

  height_auto: function height_auto() {
    return {
      styles: (0, _styledComponents.css)(_templateObject4, (0, _decisivUiUtils.px2rem)(45))
    };
  },

  readOnly: function readOnly(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject5, (0, _polished.rgba)(theme.colors.base.chrome100, 0.5), theme.colors.base.chrome200, theme.colors.base.chrome400, /* sc-sel */_ActionButton2.default)
    };
  }
};

var styles = function styles(_ref5) {
  var theme = _ref5.theme;
  return (0, _styledComponents.css)(_templateObject6, theme.colors.base.background, theme.colors.base.chrome400, (0, _decisivUiUtils.px2rem)(45), theme.colors.base.chrome600);
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome400: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Input = (0, _decisivUiUtils.buildStyledComponent)('Input', _styledComponentsReactiveGrid.Container, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

Input.ActionButton = _ActionButton2.default;

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Input/index.js
// module id = 1561
// module chunks = 2